<script lang="ts" setup>
    const props = defineProps<{
        blok: AdventcalendarDayStoryblok;
    }>();

    const emit = defineEmits<{
        (e: 'close'): void;
    }>();

    const { t } = useI18n();

    const handleClose = () => {
        emit('close');
    };
</script>

<template>
    <div class="adventcalendar-modal-wrapper">
        <div class="adventcalendar-modal-close">
            <button
                id="hub-switcher-close"
                type="button"
                class="close-button"
                data-testid="hub-switch-close-button"
                @click="handleClose"
            >
                <span class="sr-only">{{ t('general.close') }}</span>
                <img
                    src="~/assets/icons/close-white.svg"
                    alt="close"
                    aria-hidden="true"
                />
            </button>
        </div>

        <div class="adventcalendar-modal-content">
            <div
                v-if="props.blok.body"
                class="adventcalendar-modal-content-text"
            >
                <StoryblokComponentWrapper
                    v-for="headline in props.blok.headline"
                    :key="headline._uid"
                    :blok="headline"
                />
                <RichText :doc="props.blok.body" />
                <StoryblokComponentWrapper
                    v-for="button in props.blok.action"
                    :key="button._uid"
                    :blok="button"
                    size="small"
                    alignment="center"
                />
            </div>
            <div class="adventcalendar-modal-content-image">
                <StoryblokImage
                    :media="props.blok.image"
                    :type="'mainPicture'"
                    :alt="props.blok.image.alt ? props.blok.image.alt : ''"
                />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/pta-family/adventcalendar/adventcalendar-modal.scss';
</style>
